import atom from './atom.svg';
import book from './book.svg';
import heart from './heart.svg';
import person from './person.svg';
import scholar from './scholar.svg';

export default { atom, book, heart, person, scholar };
